import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { useDispatch } from "react-redux";
import { getUserProfile } from "../../redux/action/Profile";

export default function DeleteModel({
  icon,
  title,
  description,
  btnName = "Done",
  show,
  setShow,
  onDelete,
}) {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
    setShow(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setShow(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setShow(false);
  };
  useEffect(() => {
    setIsModalOpen(show);
  }, [show, isModalOpen]);

  return (
    <>
      <Modal
        title=""
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        modalRender={(modal) => (
          <div className="flex justify-center items-center w-full h-full">
            <div className="max-w-full">{modal}</div>
          </div>
        )}
      >
        <div className="h-[240px] relative px-2 py-2">
          <div className="flex flex-col justify-center items-center">
            <img src={icon} alt="img" className="w-[120px] h-[120px]" />
            <span className="text-[#4B61FF] text-[14px] font-bold text-center font-poppins">
              {title}
            </span>
            <span className="text-[#171717] text-[14px] font-poppins text-cente mt-2 text-center">
              {description}
            </span>
          </div>
          <div className="w-full gap-2 h-[40px] absolute bottom-0 flex justify-center items-center bg-[#FFFFFF]">
            <button
              className="h-[40px] w-[100px] bg-[#FFFFFF] text-[#4B61FF] font-poppins text-[14px] border-1 border-[#4B61FF] "
              onClick={handleCancel}
              style={{ border: "1px solid #4B61FF" }}
            >
              Cancel
            </button>
            <button
              className="h-[40px] w-[100px] btn-gradient rounded-xl text-[#FFFFFF] font-poppins text-[14px]"
              onClick={() => {
                setIsModalOpen(false);
                setShow(false);
                onDelete();
              }}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
